import { Injectable } from "@angular/core"
import { Md5 } from "ts-md5";

@Injectable({
    providedIn: 'root',
})
export class StringUtilsService {
    RandomString(length:number): string {
        let result = '';
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const charactersLength = characters.length;
        let counter = 0;
        while (counter < length) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
        counter += 1;
        }
        return result;
    }
    
    ToMD5(value:string): string {
        return Md5.hashStr(value);
    }

    
    ResizeTextarea(event: Event, maxHeight: number = 220): void {
        const textarea = event.target as HTMLTextAreaElement | null;
        this.ResizeTextareaElement(textarea, maxHeight);
    }

    ResizeTextareaElement(textarea: HTMLTextAreaElement | null, maxHeight: number = 220): void {
        if (!textarea) {
            return;
        }

        // Reset height to recalculate based on current content.
        textarea.style.height = 'auto';

        const nextHeight = Math.min(textarea.scrollHeight, maxHeight);
        textarea.style.height = `${nextHeight}px`;
        textarea.style.overflowY = textarea.scrollHeight > maxHeight ? 'auto' : 'hidden';
    }

}